define.alias("ember-composable-helpers/helpers/dec", "settings/helpers/dec");